import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyDashboardsAddRoute: InvariantJiraRoute = {
	name: 'legacy-dashboards-add',
	path: '(/secure/|/)AddPortalPage([!%]?[\\w]*).jspa',
};
